export default {
  courseLevelCount: '课程级数/次数',
  errorAnalysisRequireLabel: '错因要求',
  learnErrorCount: '学习错题数',
  markedErrorCount: '已标记的错题数',
  errorMarkRate: '错因标记率',
  totalQuestionCount: '总题目数',
  readCircleCount: '圈画的题目数',
  readCircleRate: '覆盖率',
  readCircleRightRate: '圈画题目正确率',
  noReadCircleRightRate: '未圈画题目正确率',
  invalidReadCircleCount: '无效圈画题目数',
  validReadCircleRate: '有效圈画率',
  chapterTaskCard: '章任务卡',
  account: '账号',
  accountBalance: '账号持有余额',
  accountDisabledTip: '该账号因【{reason}】已被禁用，不可启用。禁用方：【{source}】如有异议，请联系禁用方了解具体情况。',
  accountModifyRecord: '账号修改记录',
  /** 账号修改记录：opDescCode / opTypeCode 与后端枚举一致 */
  accountEditOpCode: {
    6155001: '创建',
    6155002: '激活',
    6155003: '升级',
    6155004: '解绑手机号',
    6155005: '解绑钉钉',
    6155006: '换绑手机号',
    6155007: '换绑钉钉',
    6155008: '补绑手机号',
    6155009: '补绑钉钉',
    6155010: '退出总部',
    6155011: '禁用',
    6155012: '启用',
    6155013: '冻结',
    6155014: '唤醒',
    6155015: '离职',
    6155016: '修改',
    6155017: '客服协助'
  },
  accountPassword: '账号密码',
  accountRoleName: '账号角色',
  accountSearch: '账号搜索:',
  accountSecurityTip: '为了保证账户安全，请先输入密码',
  accountSet: '账户管理',
  accountStatus: '账户状态',
  accountStatusLabel: '账号状态',
  accountStatusPlaceholder: '账号状态',
  accountTypeLabel: '账户类型',
  accumulatedAbnormal: '累计异常数',
  activateMonth: '软件激活月份',
  activateStatus: '软件激活状态',
  activateTime: '软件激活时间',
  active: '活跃',
  add: '新增',
  addAccount: '新增账户',
  addAccountFailed: '新增账号失败',
  addAccountSuccess: '新增账号成功',
  addAccountSuccessMsg: '新增账号成功',
  addAction: '添加',
  addAnalyst: '新增分析员',
  addCustomRole: '新增自定义角色',
  addEmployee: '添加员工',
  addEmployeeTip: '添加员工账号后，员工会收到钉钉邀请，登录钉钉即可加入',
  addFaceInfo: '补录人脸信息',
  addFailed: '添加失败',
  addInfoSuccess: '新增资料成功',
  addSchoolFail: '新增学校失败',
  addSchoolSuccess: '新增学校成功',
  addStudent: '添加学生',
  addStudentArchiveTip: '（注意：不包含未完善档案的用户，如需添加，请先完善用户档案）',
  addSuccess: '添加成功',
  agent: '代理商ID',
  agentId: '代理商ID',
  agentLabel: '代理商',
  agentName: '代理商名称',
  agentNo: '话务坐席号',
  agentNoLabel: '话务坐席号:',
  agentNoPlaceholder: '话务坐席号',
  agentTypeLabel: '代理商类型',
  all: '全部',
  already: '已使用额度',
  amount: '提货券核销的金额',
  analysisSystemAccountStatus: '分析系统账号状态',
  analyst: '分析师：',
  analystAccountStatus: '分析员账号状态',
  analystAddStudents: '分析师{name}添加学员',
  analystName: '分析员姓名',
  analystNamePlaceholder: '分析员姓名/手机号',
  answerFast: '答题过快',
  answerSlow: '答题过慢',
  applyAccount: '申请账号',
  applyAccountQuotaTip: '剩余可申请员工学习账号：{count}',
  experienceApplyConfirmTip: '操作提交后，即为{name}申领成功员工学习账号，务必敦促员工妥善使用，请确认是否继续该操作？',
  applyAnalystConfirm: '确定要为以下员工申请分析员身份吗',
  applyAnalystRole: '申请分析员角色',
  applyAnalystTitle: '申请分析员身份',
  applying: '申请中',
  approved: '审核通过',
  asset: '资产',
  assignPermissions: '分配权限',
  audioParseError: '音频解析出错，请重新上传',
  audit: '审核意见',
  authorityDetails: '分配权限',
  autumnTerm: '秋季',
  back: '返回',
  bai: '百位',
  batchAddFailed: '批量添加失败',
  batchAddStudent: '批量添加学生',
  batchAddSuccess: '批量添加成功',
  batchCancelAssignFail: '批量取消分配失败',
  batchCancelAssignSuccess: '批量取消分配成功',
  batchRemoveFailed: '批量移除失败',
  batchRemoveStudent: '批量移除学生',
  batchRemoveSuccess: '批量移除成功',
  beforeLastMonthHighActiveRate: '上上月高活占比',
  bindMobile: '绑定手机号',
  bindMobileSuccess: '绑定手机号成功！',
  bonusGranted: '是否已发放奖金',
  buyNum: '采购数量',
  callSystem: '话务系统',
  callTime: '拨打时间',
  cancel: '取消',
  cancelInvite: '取消邀请',
  channelAgentName: '渠道代名称',
  checkAddTip: '请勾选需要添加的学生',
  checkRemoveTip: '请勾选需要移除的学生',
  chineseBaseDuration: '语文打基础，累计时长',
  chineseBaseProgress: '语文打基础，最高进度',
  chuangjian: '创建人',
  ci: '次数',
  city: '城市',
  claimInternalAccount: '申领内部体验账号',
  claimTime: '申领时间',
  claimUser: '申领人',
  clearFilter: '清除筛选',
  clickToSelect: '点击选择',
  collapse: '收起',
  completePaymentTime: '完款时间',
  completed: '已完成',
  completionStatus: '完成情况',
  confirm: '确定',
  confirmAndConfigPermission: '确定并配置权限',
  confirmDeleteCustomIdentity: '确认要删除该自定义身份吗？',
  confirmResetPassword: '确认重置密码吗？',
  consecutiveError: '连错',
  contractPaidAmount: '合同款支付金额',
  copy: '复制',
  copySuccess: '复制成功',
  course: '课程',
  courseLevelTimes: '课程级数/次数',
  createSuccess: '创建成功',
  createTime: '创建时间',
  createTimeLabel: '创建时间',
  currentSupervisor: '当前督学师',
  customIdentityDesc: '自定义身份描述：',
  customIdentityName: '自定义身份名称：',
  customRole: '自定义角色',
  customer: '请选择转介绍客户ID',
  customerName: '客户姓名/手机号',
  customerPhone: '客户电话',
  customerArea: '客户所在区域',
  dai: '渠道代ID',
  daiji: '累计渠道代级别',
  dailyActivationTime: '日均激活量时间',
  dailyUpdateTip: '每日更新前一天数据，每周一固定上周数据',
  dataAnalysisPassword: '数据分析服务系统密码',
  dataAnalysisSystem: '大模型数据分析服务系统',
  dataAnalysisUsername: '数据分析服务系统用户名',
  dataPermissionConfig: '数据权限配置',
  dataPermissionDesc: '决定员工可以看到哪些数据',
  dataUpdateTime: '数据更新时间：',
  dataUpdatedTo: '数据更新至：',
  date: '日期',
  dateLabel: '日期',
  dateRangeTo: '至',
  day: '全日制',
  dayci: '单日连错次数',
  dayhour: '单日学习发呆或中途离开时长占比',
  daze: '发呆',
  dealer: '转介绍经销商续费奖励比例',
  dealerPassword: '经销商系统/小程序密码',
  dealerSystem: '经销商系统',
  dealerSystemOnly: '仅经销商系统',
  dealerSystemPlusAnalysis: '经销商系统+辅助分析系统',
  dealerSystemTip: '如需使用经销商小程序，请先勾选"经销商系统"',
  dealerUsername: '经销商系统/小程序用户名',
  delete: '删除',
  deleteCustomIdentityTip: '删除后将不会影响之前使用该自定义身份配置权限的员工。',
  deleteFailed: '删除失败',
  deleteInfoSuccess: '删除资料成功',
  deleteRole: '删除角色',
  deleteSuccess: '删除成功',
  deliverOrderValueExport: '发货订单价值明细报表导出',
  desc: '描述',
  detail: '详情',
  deviceStatusActivated: '已激活',
  deviceStatusFrozen: '冻结',
  deviceStatusLabel: '设备状态',
  deviceStatusSubscribed: '已订阅',
  deviceStatusUnactivated: '未激活',
  deviceUseStatus: '设备使用状态',
  deviceUseTime: '设备使用时间',
  dianhua: '介绍人电话',
  difficultyExplain: '难度等级表讲解能力',
  dimension: '维度',
  dimensionHighActive: '高度活跃',
  dimensionRetention: '3月服务留存率',
  dimensionStudyAbnormal: '学习过程异常',
  dimensionStudyDuration: '学习时长',
  dimensionStudyTrace: '学习留痕',
  disNo: '外呼显示手机号',
  disNoPlaceholder: '外呼显示手机号',
  disable: '禁用',
  disableAccountConfirmTip: '账号禁用操作提交后，{username}的{phone}关联账号将无法使用该账号访问{systemName}，请确认是否继续该操作？',
  /** 禁用确认弹窗：后端 systemType 2、3；1 沿用 dealerSystem */
  disableAccountAccessSystemAgent: '代理商系统',
  disableAccountAccessSystemAnalyst: '分析师系统',
  disableConfirm: '是否禁用账户',
  disableSuccess: '禁用成功',
  experienceDisableConfirmTip: '禁用操作提交后，{name}的员工学习账号将无法在学习机正常使用，请确认是否继续该操作？',
  disableTip: '禁用后，该账户不可登录或操作经销商系统',
  disabled: '禁用',
  dispatchMonth: '发货月份',
  dispatchNum: '发货数量',
  dispatchQuantity: '发货数量',
  dispatchTime: '发货时间',
  dispatchType: '发货方式',
  district: '区县',
  doubleOrder: '是否双重订单',
  downloadDetailData: '下载明细数据',
  draftCorrectRate: '书写草稿题目的正确率',
  draftMarkRateLabel: '草稿留痕率',
  draftPassRateLabel: '草稿步骤合格率',
  draftQualifyHelp: '如何判断草稿书写是否合格？',
  draftRate: '抽查草稿步骤合格率',
  draftStepPassRate: '草稿步骤合格率',
  draftWriting: '草稿书写情况',
  draftWritingRate: '草稿步骤书写率',
  durationMin: '时长(分)',
  edit: '编辑',
  editAccount: '编辑账户',
  editAccountFailed: '编辑账号失败！',
  editAccountFailedMsg: '编辑账号失败',
  editAccountSuccess: '编辑账号成功',
  editFailed: '编辑失败',
  editRole: '编辑角色',
  editSchoolSuccess: '编辑学校成功',
  editSuccess: '编辑成功',
  effectiveDuration: '有效时长',
  effectiveFoundationTime: '有效打地基时长',
  effectiveScoreCollectRate: '有效成绩收集率',
  effectiveScoreNum: '有效成绩学员数',
  effectiveScoreRate: '有效成绩率',
  email: '邮箱',
  emailOrMobileRequired: '邮箱和手机必须填写一个！',
  invalidEmailFormat: '请输入正确的邮箱格式',
  employeeAccount: '员工账号',
  employeeAccountStatus: '员工账号状态',
  employeeName: '员工姓名：',
  employeeRole: '员工角色',
  employeesAccount: '员工账号',
  enable: '启用',
  enableConfirm: '是否重新启用账户',
  enableFailed: '启用失败',
  enableSuccess: '启用成功',
  enableSuccessMsg: '启用成功',
  enableTip: '启用后，该账户可正常登录或操作经销商系统',
  enabled: '启用',
  englishBaseDuration: '英语打基础，累计时长',
  englishBaseProgress: '英语打基础，最高进度',
  entryAccount: '入门账号',
  equipmentValueExport: '设备价值明细报表导出',
  er: '二级',
  errorAnalysis: '错因分析',
  errorAnalysisCompletion: '错因分析完成情况',
  evaluationScoreLabel: '评价分',
  errorAnalysisHelp: '错因分析如何做？',
  errorAnalysisRequired: '当孩子在做1-6级（前两次）打基础时，必须要做错因分析',
  errorAnalyzeLabel: '错因分析完成率',
  errorCount: '错题数',
  examScoreImprovementRate: '大考提分率',
  examType: '考试类型',
  examTypeLabel: '大考类型',
  exampleTrial: '例题试做情况',
  exampleTrialNorm: '例题试做规范性',
  exampleTrialRate: '例题试做率',
  exampleTrialTraceRate: '例题试做留痕率',
  exceptionLevelLabel: '级异常',
  expand: '展开',
  experienceAccount: '体验账号',
  experienceStudentCount: '负责的体验学生数',
  experiencesAccount: '员工学习账号',
  exportReport: '导出报表',
  expressCompany: '物流公司',
  expressNo: '物流单号',
  expressNoLabel: '发货单号',
  faceExistUploadCorrect: '人脸信息已存在，请上传正确的员工照片',
  faceInfoStatus: '人脸信息录入状态',
  faceVerifyStatusMissing: '人脸信息缺失',
  faceVerifyStatusRecorded: '已录人脸信息',
  faceVerifyStatusNormal: '正常（该账号不走人脸校验）',
  faceInfoRiskTip: '员工学习账号已开启智能风险防控功能，为员工申请账号需上传人脸信息后方可使用',
  faceInfoMissingPausedTip: '该员工学习账号，尚未录入人脸信息，已暂停使用。录入人脸信息后可以恢复使用。',
  faceInfoUpdatedRecentlyTip: '该员工学习账号近期已更新过人脸信息，请于{time}后再试',
  faceInfoUpdateLimitTip: '员工学习账号每两个月只能更新一次，该账户上次更新时间为{time}，请谨慎操作',
  faceInfoAgeConfirm: '照片并非成人，是否确定要使用此照片？',
  faceInfoUploadFormatTip: '只能上传JPG、JPEG、GIF、PNG、BMP格式的图片',
  facePhotoEncryptTip: '* 您所上传的照片将进行加密处理，不作他用',
  facePhotoSpec: '照片规范:',
  facePhotoSpec1: '上传照片需为正脸照',
  facePhotoSpec2: '需避免佩戴帽子、首饰',
  facePhotoSpec3: '照片背景需为白色墙壁',
  female: '女',
  fillBasicInfo: '请填写基础信息',
  fillerLabel: '填写人',
  finalExam: '期末考',
  finalPaymentTime: '最后付款时间',
  firstDispatchTime: '首次发货时间',
  firstTime: '首次',
  firstWeekFeedback: '首周反馈',
  fixedPositionComponentTip: '固定位置的组件(如: 底部导航、悬浮)不能放在第一个!',
  followLabel: '跟进：',
  followingUp: '正在跟进',
  formalStudentCount: '负责的正式学生数',
  freightAmount: '预付运费',
  frontFacePhoto: '正脸照片',
  frozen: '冻结',
  fullProcessTraining: '全流程培训',
  fulltime: '全日制',
  functionPermissionConfig: '功能权限配置',
  functionPermissionDesc: '决定员工可以看到哪些功能',
  gender: '性别',
  getDataFailed: '获取数据失败',
  getDataFailedExclaim: '获取数据失败！',
  getVerifyCode: '获取验证码',
  goldCoin: '金币',
  goldCoinUnit: '个金币',
  grade: '阶段年级',
  handover: '交接',
  handoverPerson: '交接人',
  handoverRecord: '交接记录',
  hantianCallSystem: '汉天话务系统',
  hardStatus: '硬件激活状态',
  hardTime: '硬件激活时间',
  hardwareActivateTime: '硬件激活时间',
  healthExplain: '健康度升降级讲解能力',
  healthUpDownExplain: '健康升降级讲解',
  highActive: '高度活跃',
  highestRatio: '的占比最高',
  hour: '小时',
  hourhour: '答题时长超过平均时长',
  houryici: '这时候直接用上一次的参数',
  howScoreCalculated: '评分如何计算？',
  iKnow: '我知道了',
  id: '介绍人id',
  imageFormatJpgPngOnly: '只能上传JPG、JPEG、PNG格式的图片',
  imagePositionRequired: '图片位置不能为空，请上传图片或删除该组件',
  imageSizeExceed5M: '超过5M限制 不允许上传~',
  improvedScoreNum: '提分学生数',
  info: '信息缺失',
  infoMissing: '信息缺失',
  initialPassword: '初始密码',
  initialPasswordLabel: '初始密码',
  instinctExplain: '本能级讲解',
  internalAccountTip1: '内部体验账号需于员工松鼠Ai账号绑定，请如实选择需开通的员工账号',
  internalAccountTip2: '仅账号状态为"正常"的员工可申领内部体验账号',
  introducerOrChannelAgentId: '介绍人/渠道代ID',
  invalidMobileFormat: '输入手机号格式不正确',
  investorRoleCannotModify: '主账号投资人角色不可修改',
  isFirstReward: '是否首次',
  ji: '累计渠道级别',
  jidao: '升级到',
  jie: '冻结',
  jinzhanghu: '金账户',
  knowledgeNote: '知识点笔记',
  lastMonthHighActiveRate: '上月高活占比',
  leads: '条线索',
  learnTimeLabel: '学习时长',
  learningAccountStatus: '学习账号状态',
  learningAccountExpired: '到期',
  learningAccountViolationDisabled: '违规禁用',
  leaveDateLabel: '离职日期',
  leaveMidway: '中途离开',
  leaveTimeLabel: '离职时间',
  level: '级',
  levelOne: '一级',
  levelTwo: '二级',
  levelThree: '三级',
  levelFour: '四级',
  levelFive: '五级',
  levelSix: '六级',
  levelSeven: '七级',
  levelEight: '八级',
  levelNine: '九级',
  levelTen: '十级',
  listenRecording: '听录音',
  loginPassword: '登录密码：',
  mainSystem: '主系统：',
  male: '男',
  markSupervisorInfo: '标记督学信息',
  mathBaseDuration: '数学打基础，累计时长',
  mathBaseProgress: '数学打基础，最高进度',
  messageExport: '消息导出',
  messageReadUserCount: '已读数',
  messageSendDate: '发送日期',
  messageSendUserCount: '发送人数',
  midtermExam: '期中考',
  min: '错因分析',
  minhour: '分页的时候',
  mobile: '手机号',
  mobileModifyTip: '注意：如需修改员工登录手机号码，请员工登录账号后，前往账号安全中心进行修改。',
  mobileModifyTip2: '注意:如需修改员工手机号，请在开通账号后由员工登录账号前往账号安全中心修改',
  modifyAnalyst: '修改分析员',
  modifyInfoSuccess: '修改资料成功',
  modifyRecord: '修改记录',
  modifySuccess: '修改成功',
  month: '月份',
  monthDataLabel: '月数据',
  monthActive: '月活跃',
  more: '更多',
  msgDesc: '描述',
  msgTitle: '标题',
  name: '姓名',
  nameLabel: '姓名:',
  namePlaceholder: '姓名',
  nameRequired: '姓名不能为空',
  newOrderNo: '最新采购单号',
  newStudentName: '新生姓名',
  newStudentNameOrPhone: '新生姓名或者手机号',
  newStudentPeriod: '新生周期',
  newSupervisorNum: '新增督学学员数',
  newSupervisorNumTip: '本月新标记督学状态是自习室或仅线上的学员数',
  nineMonthRetentionRate: '9月服务留存率',
  nineMonths: '9个月',
  noCollectNum: '收集不到成绩学生数',
  noDraftCorrectRate: '未书写草稿题目的正确率',
  noExceptionThisWeek: '本周没有异常情况哦！',
  noQualifiedStudents: '没有符合添加条件的学生',
  noRecording: '未传录音',
  noSupervisorActiveNum: '未督学活跃学员数',
  noSupervisorNum: '未督学学员数',
  noSupervisorNumTip: '未督学：未标记督学状态，或督学状态是督学到期，不督学',
  normal: '正常',
  notApplied: '未申请',
  notCompleted: '未完成',
  num: '发货数量',
  onlineOnlyNum: '仅线上学员数',
  onlyOneComponentTip: '当前组件只能添加一个!',
  opDesc: '操作描述',
  opTime: '操作时间',
  opType: '操作类型',
  opUser: '操作人',
  opUserLabel: '操作人',
  operation: '操作',
  optional: '选填',
  order: '赊货订单已发货未付款的订单裂变金额',
  orderAmount: '订单金额',
  orderCreateTime: '订单创建时间',
  orderNo: '订单编号',
  orderQuantity: '订单数量',
  orderStatus: '订单状态',
  orderStatusLabel: '订单状态',
  orderTime: '下单时间',
  orderType: '订单类型',
  outerDisplayMobile: '外显手机号：',
  pagePermissionConfig: '页面权限配置',
  pagePermissionDesc: '决定员工可以看到哪些页面',
  paidAmount: '实收金额',
  password: '密码',
  passwordResetSuccess: '密码已重置为songguo123',
  passwordResetSuccessMsg: '账户{name}密码已重置为songguo123',
  passwordResetTo: '账户{name}密码已重置为songguo123',
  payStatus: '完款状态',
  payStatusLabel: '支付状态',
  payStatusNotPaidInFull: '未完款',
  payStatusReceived: '已收款',
  payStatusUnpaid: '未付款',
  accountDraft: '草稿',
  payedTotalAccountAmount: '已付现金总金额',
  payedTotalVoucherAmount: '已付裂变奖金抵扣金额',
  paymentTime: '付款时间',
  pending: '待确认',
  pendingConfirm: '待确认',
  permissionCheckTip: '*请在下方表单中勾选此身份拥有的权限',
  person: '人',
  pineconeOrder: '松果订单',
  playRecording: '播放录音',
  pleaseEnter: '请输入采购单号',
  pleaseEnterPlain: '请输入',
  pleaseEnterAdName: '请输入广告名称',
  pleaseEnterBindMobile: '请输入绑定的手机号',
  pleaseEnterCorrectMobile: '请输入正确的手机号',
  pleaseEnterEmail: '请输入电子邮箱',
  pleaseEnterLoginPassword: '请输入登录密码',
  pleaseEnterMobile: '请输入手机号,可用于找回密码',
  pleaseEnterMsgTitle: '请输入消息标题',
  pleaseEnterName: '请输入姓名',
  pleaseEnterOrderNo: '请输入订单编号',
  pleaseEnterProductName: '请输入商品名称',
  pleaseEnterPurchaseOrderNo: '请输入采购订单编号',
  pleaseEnterRemark: '请输入备注',
  pleaseEnterSchoolName: '请输入学校名称',
  pleaseEnterStudentName: '请输入学生姓名',
  pleaseEnterStudentPhone: '请输入学生手机号',
  pleaseEnterTrueName: '请输入真实姓名',
  pleaseEnterVerifyCode: '请输入验证码',
  pleaseFillExpressNo: '请填写快递单号！',
  pleaseFillMsgDesc: '请填写消息描述',
  pleaseFillOrderTimeOrDispatchTime: '请先填写下单时间或发货时间',
  pleaseFillPageName: '请在页面设置中填写页面名称',
  pleaseFillRoleName: '请填写自定义身份名称',
  pleaseSelect: '请选择',
  pleaseSelectAccountStatus: '请选择账号状态',
  pleaseSelectAccountType: '请选择账户类型',
  pleaseSelectActivityTimeRange: '请选择活动开始时间-结束时间',
  pleaseSelectAdPosition: '请选择广告位置',
  pleaseSelectAddStudents: '请选择要添加的学生',
  pleaseSelectAgent: '请选择代理商',
  pleaseSelectAgentNo: '请选择坐席号',
  pleaseSelectAgentType: '请选择代理商类型',
  pleaseSelectAnalyst: '请选择分析师',
  pleaseSelectAnalystAccountStatus: '请选择分析员账号状态',
  pleaseSelectCallSystem: '请选择话务系统',
  pleaseSelectDisNo: '请选择外显手机号',
  pleaseSelectEmployee: '请选择员工',
  pleaseSelectExpressCompany: '请选择快递公司',
  pleaseSelectExtNo: '请选择分机号',
  pleaseSelectGender: '请选择性别',
  pleaseSelectHandover: '请先选择交接人！',
  pleaseSelectLinkData: '请选择需要关联的数据',
  pleaseSelectMainSystem: '请先选择主系统',
  pleaseSelectMonth: '请选择月份',
  pleaseSelectOrderStatus: '请选择订单状态',
  pleaseSelectOrderType: '请选择订单类型',
  pleaseSelectOuterDisplayMobile: '请选择外显手机号',
  pleaseSelectPayStatus: '请选择完款状态',
  pleaseSelectPerson: '请选择人员',
  pleaseSelectProductType: '请选择商品类型',
  pleaseSelectRemoveStudents: '请选择要移除的学生',
  pleaseSelectSchoolRegion: '请选择学校省市区',
  pleaseSelectStatus: '请选择状态',
  pleaseSelectSubject: '请选择学科',
  pleaseSelectSupervisor: '请选择督学师',
  pleaseSelectSupervisorStatus: '请选择督学状态',
  pleaseSelectTeachingStage: '请选择授课阶段（可多选）',
  pleaseSelectTeachingSubject: '请选择授课科目',
  pleaseSelectUpgradeLevel: '请先选择升级等级',
  pleaseSelectWarehouse: '请选择仓库',
  pleaseSelectYear: '请选择年份',
  placeholderSelectMonth: '请选择月份',
  monthLabel: '月份',
  monthNumberLabel: '{n}月',
  allOption: '全部',
  pleaseUploadFacePhoto: '请按规范上传正脸照片',
  pleaseUploadImage: '请上传图片',
  pointsSuffix: '分',
  potentialCustomer: '潜在客户',
  previewPermission: '预览权限',
  price: '现金单价',
  priceIncreaseAmount: '涨价金额',
  productModel: '商品型号',
  productName: '采购产品名称',
  productPrice: '采购产品单价',
  productType: '商品类型',
  province: '省份',
  provinceActivateExport: '省份激活数据报表导出',
  provinceAverage: '省平均',
  provinceCityDistrict: '省市区',
  provincialPending: '待省平台评分中',
  purchase: '采购单价',
  purchaseAmount: '采购金额',
  purchaseNum: '采购数量',
  purchaseOrderNo: '采购订单编号',
  purchaseOrderValueExport: '采购订单价值明细报表导出',
  purchaseQuantity: '采购数量',
  purchaseTotalAmount: '采购总金额',
  purchaseUnitPrice: '采购单价',
  qing: '申请人',
  quantity: '数量',
  qudai: '区代ID',
  qudaifen: '区代分担增值服务费',
  qudaifending: '区代分担订阅费返佣',
  queryDate: '查询日期',
  questionCount: '题目数',
  questionMarkRateLabel: '题目圈画情况',
  quickConfigTip: '请选择子账号身份，系统将自动快速配置子账号所需的权限',
  quickConfigTip2: '（配置后，也可手动调整）',
  quickIdentity: '自定义快捷身份',
  quickSearchAddPermission: '快捷搜索添加权限',
  reInvite: '重新邀请',
  reInviteSuccess: '已重新邀请，请提醒员工前往钉钉查收',
  reactivate: '重新激活',
  readCircle: '读题圈画情况',
  readCircleCoverageRate: '读题圈画覆盖率',
  readCircleEffectiveRate: '读题圈画有效率',
  readCircleHelp: '如何做好读题圈画？',
  reapply: '重新申请',
  receiveAddress: '收货地址',
  receiveByName: '收货人',
  recentThreeScores: '最近三次成绩',
  rechargeTime: '充值时间',
  referralContractAmount: '转介绍签约金额',
  referralCustomerId: '转介绍客户ID',
  referralCustomerName: '转介绍客户名称',
  regionAgentId: '区代ID',
  regionShareSubscriptionRebate: '区代分担订阅费返佣',
  regionShareValueAddedFee: '区代分担增值服务费',
  rejected: '审核驳回',
  release: '释放',
  remark: '备注',
  remove: '移除',
  removeFail: '移除失败',
  removeFailed: '移除失败',
  removeSuccess: '移除成功',
  renew: '续期',
  renewSuccess: '续期成功',
  experienceRenewConfirmTip: '续期操作单次仅可续期1年，操作提交后，即为{name}申领的员工学习账号完成订阅时长的续期，务必敦促员工妥善使用，请确认是否继续该操作？',
  replenishmentTime: '补货时间',
  requestFailRetry: '请求失败，请稍后重试',
  resendAfter: '{count}s后重新发送',
  resetFailed: '重置失败',
  resetPassword: '重置密码',
  resetPasswordAfterTip: '重置后，密码为初始密码【songguo123】',
  resetPasswordConfirm: '是否重置账户',
  resetPasswordTip: '的登录密码',
  resetPasswordTitle: '重置密码',
  resetSuccess: '重置成功',
  resign: '离职',
  resignAssetTip: '该员工账号有以下资产，请选择释放或交接',
  resignConfirmTip: '账号离职操作提交后，{name}的{mobile}关联账号相关数据将被清空，同时其钉钉组织将被移除，离职操作提交后将无法撤回，请确认是否继续该操作？',
  resignFailed: '离职失败',
  resignOperation: '离职操作：',
  resignRecord: '离职记录',
  resignSuccess: '离职成功',
  resignSuccessTip: '离职操作成功后，该员工账号将从ID{campusId}下删除并无法恢复',
  resigned: '离职',
  responsibleSupervisor: '负责督学师',
  restart: '重启',
  returnBackPayValue: '是否回款',
  rewardAmount: '奖励金额',
  rewardRate: '奖励比例',
  sampleAccount: '样机账号',
  san: '三级',
  save: '保存',
  saveFailed: '保存失败',
  saveSuccess: '保存成功',
  schoolDataBase: '资料库',
  schoolYear: '学年',
  score: '成绩',
  scoreCollectRate: '成绩收集率',
  scoreCollected: '成绩收集（总）',
  scoreImprovementRate: '提分率',
  scoreLabel: '成绩',
  scoreManage: '成绩管理',
  scoreRule1Basis: '评分依据：根据督学学生平均周学习时长',
  scoreRule1Text1: '春秋季：平均周学习6小时得10分',
  scoreRule1Text2: '寒暑假：平均周学习20小时得10分',
  scoreRule1Text3: '每月得分 = 当月所有周得分的平均分',
  scoreRule1Title: '1. 学习时长',
  scoreRule2Basis: '评分依据：根据督学学生高度活跃占比',
  scoreRule2Text1: '以全国平均为基准，占比每高出10%就加1分，每低10%就减1分',
  scoreRule2Text2: '每月得分 = 当月所有周得分的平均分',
  scoreRule2Title: '2. 高度活跃',
  scoreRule3Basis: '评分依据：根据督学学生学习过程异常情况',
  scoreRule3Text1: '每个学生每周有10分基础分，出现异常会被扣分',
  scoreRule3Text2: '异常等级不同扣分不同，春秋寒暑的扣分标准有区别',
  scoreRule3Text3: '当周的得分是督学学生得分的平均分',
  scoreRule3Text4: '每月得分 = 当月所有周得分的平均分',
  scoreRule3Title: '3. 学习过程异常',
  scoreRule4Basis: '评分依据：根据督学过程的留痕率',
  scoreRule4Text: '根据督学过程的留痕率平均值 × 10, 来计算得分',
  scoreRule4Title: '4. 学习留痕',
  scoreRule5Basis: '评分依据：根据督学结果的3月服务留存率',
  scoreRule5Text1: '得分 = 督学结果的3月服务留存率 × 10',
  scoreRule5Text2: '注意：新人督学师(3个月内)此项不计算',
  scoreRule5Title: '5. 3月服务留存率',
  scoreRuleTotalDesc: '总分（满分10分）由以下5个维度的表现共同决定。',
  search: '搜索分析员:',
  searchAnalyst: '搜索分析员:',
  secmin: '秒转换分钟',
  securityVerification: '安全验证',
  selectEmployee: '选择员工：',
  selectMainSystem: '选择使用系统',
  selectRolePermission: '选择角色权限',
  selfProcessExplain: '自主流程讲解',
  selfScoreLabel: '自评',
  selfStudyNum: '自习室学员数',
  send: '发送',
  sendFail: '发送失败',
  sendSuccess: '发送成功',
  serviceCenterAllStudents: '服务中心所有学员',
  serviceRetentionRate: '服务留存率',
  serviceRetentionRateTip: '3月服务留存率：3个月前转入服务中心的学生，本月还有多少比例的人仍在此服务中心且月学习时长≥4小时。\n6月、9月、12月服务留存率同理，只是时间跨度分别延长到6个月前、9个月前和12个月前。',
  serviceTeacher: '督学师',
  settlementMonth: '结算年月',
  shi: '十位',
  shu: '奖励系数',
  sixMonthRetentionRate: '6月服务留存率',
  sixMonths: '6个月',
  skipVideo: '跳视频',
  snCode: '设备SN码',
  softwareActivateTime: '软件激活时间',
  softwareActiveMonth: '软件激活月份',
  softwareActiveStatus: '软件激活状态',
  splitUser: '业绩分单人',
  splittingTime: '分单时间',
  springTerm: '春季',
  squirrelOrder: '松鼠订单',
  stageGrade: '阶段年级',
  statsPeriodLabel: '统计周期',
  status: '分析系统账号状态',
  student: '学生',
  studentAccount: '学员账号',
  studentData: '学员数据',
  studentInfoIncomplete: '学生信息不完整，无法移除',
  studentManage: '学生管理',
  studentNameLabel: '学生姓名',
  studentPhoneLabel: '学生手机号',
  studentsCount: '名学员',
  studentsOfTeacher: '{name}负责的学生',
  studyAbnormal: '学习过程异常',
  studyAbnormalHelp: '学生学习过程出现异常怎么办？',
  studyAbnormalOverview: '学习异常概览',
  studyAbnormalScene: '学习异常场景说明',
  studyAccuracy: '学习正确率',
  studyDuration: '学习时长',
  studyMonitorAlert: '学习过程监课报警说明',
  studyTrace: '学习留痕',
  subject: '学科',
  subjectLabel: '学科',
  submit: '提交',
  submitFailed: '提交失败',
  submitScoreNum: '提交成绩学员数',
  submitSuccess: '提交成功',
  submitTwiceNum: '提交两次成绩学生数',
  subscribeSubject: '订阅学科',
  subscriptionFeeAmount: '订阅费金额',
  subscriptionFeeRebate: '订阅费返佣',
  subsequentError: '后续答题错误',
  summaryFillCount: '小结填写次数',
  superviseStudent: '督学学员',
  supervising: '正在督学',
  supervisor: '督学：',
  supervisorColon: '督学：',
  supervisorData: '督学师数据',
  supervisorLabel: '督学师：',
  supervisorManage: '督学管理',
  supervisorName: '督学师姓名',
  supervisorNoData: '{names}等{count}位督学师暂无数据',
  supervisorStatus: '督学状态',
  supervisorStudents: '督学的学生',
  supervisorSummaryCoverageTip: '督学小结覆盖率：每周单科学习时长≥50分钟的学生，填写了督学小结的人科数占比',
  supervisorSummaryFillRate: '小结填写率',
  supervisorSummaryLabel: '督学小结',
  supervisorSummaryWeek1: '督学小结覆盖率，第一周',
  supervisorSummaryWeek2: '督学小结覆盖率，第二周',
  supervisorSummaryWeek3: '督学小结覆盖率，第三周',
  supervisorSummaryWeek4: '督学小结覆盖率，第四周',
  supervisorSummaryWeek5: '督学小结覆盖率，第五周',
  studentSummaryFillRate: '督学小结填写率',
  supervisorValidUntil: '督学有效期至',
  supplementReward: '补返',
  teacher: '分析师',
  teacherManage: '分析师管理',
  teacherManagement: '分析员管理',
  teacherNameLabel: '督学师姓名',
  teacherScoreManage: '督学师的成绩管理',
  teachingStage: '授课阶段',
  teachingSubject: '授课科目',
  tenPoints: '10分',
  term: '学期',
  text0gz9: '取出不同项',
  text0mll: '如果当前位是',
  text0tr2: '或者更换了搜索条件',
  text0w3u: '书写草稿题目的正确率',
  text0w9z: '督学过程',
  text0x15: '都设置为默认的',
  text17ch: '督学师数据',
  text1926: '检查是否为有效数字',
  text2vs2: '且答案不正确',
  text39f7: '使用插槽自定义显示',
  text3mvs: '获取所有的督学师',
  text3pv9: '转换为数字类型',
  text3u4k: '服务留存率',
  text3xl2: '处理',
  text40ep: '结构',
  text489f: '答题过慢',
  text48yo: '答题过慢且做错',
  text49aa: '草稿步骤书写率',
  text4h9c: '做错',
  text4t75: '读题圈画情况',
  text627i: '单周',
  text6g6k: '例题试做合格率',
  text6ntj: '那么',
  text7141: '做了',
  text76xd: '使用',
  text78b4: '试做错误看了视频不会',
  text7hj4: '而不是',
  text82nx: '严重程度',
  text8f95: '播放音乐',
  text8mo7: '任务卡',
  text8ocs: '显示为',
  text9437: '请选择督学师',
  text99pk: '标签的停止播放事件',
  text9fgp: '通过命名插槽自定义显示',
  text9g2t: '例题试做数',
  text9rrm: '注册全局事件监听器',
  text9vdz: '供子组件获取督学师数据',
  text9ymf: '周数据',
  texta01x: '总题数的',
  texta4yg: '或未播放',
  texta9jk: '知识点',
  textafry: '其他模块直接导入使用',
  textah6t: '作对比',
  textaj3b: '需要添加',
  textas1f: '不专注',
  textatdj: '对比两个数组',
  textb13r: '自定义通讯名',
  textb1td: '销毁订阅',
  textb3iv: '转换数据格式',
  textb42m: '异常级别和严重程度表格配置',
  textb57b: '单周超过',
  textb9f4: '督学师',
  textbnko: '督学结果',
  textbw1c: '使用插槽类型',
  textc6ge: '督学师成长',
  textcbtu: '试错结果',
  textclml: '或者是手动置空之后点击搜索',
  textd04f: '学习正确率',
  textdbku: '答题过慢或者过快且做错的题目数',
  texte5xq: '需要特殊处理',
  texte71e: '异常级别',
  textehfn: '未书写草稿题目的正确率',
  texteoqz: '播放结束',
  textfri7: '离开学习界面',
  textg9jw: '不合格',
  textg9lu: '整体正确率',
  textg9q3: '例题试做留痕率',
  textgq8m: '草稿合格率',
  texthcky: '移除事件监听器',
  texthhgq: '学生数据',
  texthmgc: '连错',
  texthvgt: '高度活跃率',
  texthyxj: '跳视频且做错',
  texti83z: '超过',
  texticoe: '监听',
  textif5e: '播放进度',
  textiixp: '便于逐位处理',
  textio06: '处理数据',
  textiqb0: '题答案不正确',
  textj0nj: '抽查试题试做评价',
  textj25c: '督学数据表格标题',
  textj3ol: '没做',
  textj5rx: '点击',
  textj9q6: '督学师姓名',
  textjml8: '总题目数',
  textjo43: '后续的题目做错',
  textkm2l: '可以开始播放事件',
  textkoo8: '个位',
  textl7dp: '且正确率',
  textlmp2: '例题试做率低',
  textlysd: '报警情况',
  textmgeu: '督学数据表格数据',
  textmj7g: '草稿步骤书写情况',
  textml6j: '从右到左的位置',
  textmvg4: '添加数字和单位',
  textmxwo: '标签的暂停事件',
  textn2me: '位督学师暂无数据',
  textn6iq: '获取播放的位置',
  textn73g: '课程级数',
  textnbar: '缓存数据',
  textneeb: '合格',
  textnz99: '将数组结构转换为',
  textoida: '视频例题试做情况',
  textoros: '更新当前组件的',
  textot2j: '标签的音频加载完成事件',
  textowbi: '草稿书写率低',
  textp2cw: '将数字转换为字符串',
  textp3v5: '所以这个必须设置为',
  textpi0u: '读题圈画留痕率',
  textpq4z: '试做正确',
  textpr2f: '草稿步骤书写数',
  textpruy: '发呆',
  textq0ee: '和所有督学师列表对比',
  textqp4o: '视频',
  textr44b: '原创面板',
  textrcak: '春秋',
  textrfhl: '知识点笔记',
  textri2f: '答题过快',
  textrqvd: '学习状态不在线',
  textsp46: '跳视频',
  textt2sn: '高度活跃率',
  textt9gm: '连续有',
  texttcnp: '服务留存率',
  textte0m: '基本数字映射',
  texttsu0: '触发条件',
  textu6da: '督学数据表格数据总数',
  textujf7: '播放状态',
  textuom8: '试做错误看了视频会了',
  textup01: '草稿留痕率',
  textv7bp: '学习过程监课报警说明表格配置',
  textv7f9: '需等音频加载完成',
  textvbft: '寒暑',
  textw0yx: '跳过视频且错',
  textw70q: '例题试做率',
  textw887: '题做了',
  textwfar: '总视频数',
  textwnem: '点击清空按钮',
  textwnfr: '单周触发异常场景',
  textxq0a: '题中有答案不正确',
  textxus0: '中途离开',
  textxw4v: '否则都应为默认的',
  texty2le: '且未书写草稿题目正确率',
  texty46b: '录音播放',
  texty6ox: '新生管理',
  textyiin: '督学数据',
  textyk6y: '拖拽面板进度条',
  textylh1: '处理可以开始播放事件',
  textynd0: '草稿合格率',
  textypuv: '全部题做了',
  textys7i: '胡乱答题',
  textz0mj: '处理特殊情况',
  textzgl8: '答题过快且做错',
  textzmi8: '格式',
  textznuz: '知识点笔记留痕率',
  textzpjo: '只查询在职教师',
  textzrhn: '映射',
  textzt6o: '小结填写率',
  textzun2: '学不动',
  thisMonthHighActiveRate: '本月高活占比',
  threeMonthRetention: '三月服务留存率',
  threeMonthRetentionRate: '3月服务留存率',
  threeMonths: '3个月',
  time: '时间',
  times: '次数',
  timesDesc: '次数说明',
  tizhanghu: '提货券账户',
  totalAccountAmount: '现金金额（含提货券）',
  totalCorrectRate: '整体正确率',
  totalErrorCount: '总错题数',
  totalLearnTime: '累计学习时长',
  totalPrice: '单价合计',
  totalReturnedAmount: '累计已返金额',
  totalScore: '总分',
  totalScoreLabel: '总得分',
  totalStudyDuration: '总学习时长',
  totalVoucherAmount: '裂变金额',
  transferCampusId: '发货区代ID',
  transferCampusName: '发货区代名称',
  trialAccount: '尝鲜账号',
  trialDate: '试做日期',
  trialErrorKnowledge: '试做错误的知识点',
  trialErrorResult: '试错结果',
  trialErrorWatchVideoNotOk: '试做错误看了视频不会',
  trialErrorWatchVideoOk: '试做错误看了视频会了',
  trialStillNotOkSuffix: '个视频的试做看了仍然不会，请关注',
  trialStillNotOkTip: '，有',
  twelveMonthRetentionRate: '12月服务留存率',
  twelveMonths: '12个月',
  type: '账号类型',
  unit: '个',
  updateFaceInfo: '更新人脸信息',
  updateTime: '修改时间',
  uploadFail: '上传失败',
  uploadSizeExceed1MB: '上传文件大小不能超过1MB',
  uploadSuccess: '上传成功',
  uploadedImages: '上传的图片',
  userName: '用户名',
  valueAddedServiceFee: '增值服务费',
  verifyCode: '验证码：',
  verifyFailed: '验证失败！',
  verifySuccess: '验证成功！',
  view: '查看',
  viewAccountPassword: '查看账号密码',
  viewAll: '查看全部＞',
  viewDetail: '查看明细',
  viewFail: '查看失败',
  viewImage: '查看图片',
  viewStudent: '查看学生',
  viewStudentLabel: '查看学生',
  viewSummary: '查看小结',
  viewTrialErrorKnowledge: '查看试做错误的知识点',
  voucherPrice: '裂变单价',
  vsLastMonth: '较上月',
  wake: '唤醒',
  wakeConfirmTip: '账号唤醒操作提交后，{username}的{phone}关联账号可正常访问{systemName}，并加入当前的{campusId}钉钉部门，请确认是否继续该操作？',
  wakeFailed: '唤醒失败',
  wakeSuccess: '唤醒成功',
  warehouse: '仓库',
  week: '统计周期',
  weekAlarmCount: '本周累计报警数',
  weekEndDate: '周（截止日期）',
  weekErrorAnalysisRate: '本周1-6级错因分析完成率',
  weekTrialRatio: '本周例题试做率',
  weight: '权重',
  weight25: '25%',
  weightNewOld: '25%(新人) / 25%(非新人)',
  weightRetention: '0%(新人) / 10%(非新人)',
  withdraw: '提现账户',
  within10Chars: '10个字以内',
  within30Chars: '30个字以内',
  wrongAndNotOk: '错误，还是不会',
  wrongAndOk: '错误，会了',
  wu: '无效',
  year: '年份',
  yearSuffix: '年',
  yes: '是否已发奖励',
  yi: '一级',
  yihour: '每一道答题时长',
  yishi: '一十',
  yixunCallSystem: '易迅话务系统',
  yong: '禁用',
  yonge: '可用额度',
  you: '有效',
  youqi: '有效期',
  zhanghu: '裂变账户',
  actualAmount: '实付金额',
  export: '导出',
  hao: '采购单号',
  text0o0d: '采购量',
  text23z5: '厂商发货管理',
  text2b7i: '现金账户',
  text3m5o: '导入详情',
  text8kdk: '裂变奖金账户',
  text8ojn: '导入详情列表',
  textb2w1: '或者是手动置空之后点击搜索',
  textbsxw: '点击清空按钮',
  textc66c: '下载导入结果',
  textffcb: '提货券账户',
  textfkn9: '那么',
  texthgq2: '账户余额',
  texti0u5: '已导入',
  textj87y: '采购金额',
  textke1h: '取消订阅',
  textkf9v: '导入类型',
  textkh28: '金账户',
  textm22h: '否则都应为默认的',
  textn0ux: '最高可抵扣',
  textose4: '都设置为默认的',
  textspvo: '可用金额',
  textuuw6: '总数据量',
  textvla9: '表格数据查询',
  textym5z: '或者更换了搜索条件',
  textzx8x: '未导入',
  auto_114_bf5738cf: '暂时不需要做',
  auto_115_54bf2acb: '没做',
  auto_116_6ce2c91b: '题做了',
  auto_117_5a0eda5e: '题做了',
  auto_118_c996d044: '题做了',
  auto_119_47f91cb3: '全部题做了',
  auto_120_87db356c: '做了',
  auto_121_dac8b361: '没做',
  auto_122_6d225d37: '暂时不需要做',
  auto_123_b8340646: '合格',
  auto_124_13c6e860: '不合格',
  auto_125_b455aa66: '一级',
  auto_126_52e5e119: '二级',
  auto_127_601a8062: '单周超过次或连续周触',
  auto_128_9f36d418: '三级',
  auto_129_5823f537: '单周超过次或连续周触',
  auto_130_82661969: '学习状态不在线',
  auto_131_c2c2e569: '单日学习发呆或中途离',
  auto_132_ab17e28a: '学不动',
  auto_133_435003ac: '单日连错次数次',
  auto_134_39dc31a3: '胡乱答题',
  auto_135_c36ab2f9: '单日学习答题过快的题',
  auto_136_9b4acfbb: '不专注',
  auto_137_e0addb98: '单日学习答题过慢的题',
  auto_138_44b28708: '多次跳视频做错',
  auto_139_6ca2cf8a: '单日学习跳视频且后续',
  auto_140_05a4538b: '草稿书写率低',
  auto_141_19e584cd: '单日草稿书写率低于且',
  auto_142_599c751f: '例题试做率低',
  auto_143_f7e255db: '单日例题试做率',
  auto_144_6ce6fdb2: '错因分析完成率低',
  auto_145_82ea5516: '单周级错因分析完成率',
  auto_146_34ea6de7: '学习时长过低',
  auto_147_0ddc1e9b: '单周学习时长春秋小时',
  auto_148_8be52cf5: '发呆',
  auto_149_e1cbdb93: '超过分钟停留原页面无',
  auto_150_3a20f613: '中途离开',
  auto_151_5adffc36: '离开学习界面',
  auto_152_19f7a463: '连错',
  auto_153_3771d346: '连错题答案不正确',
  auto_154_86a7f26f: '答题过慢且做错',
  auto_155_5c563bec: '答题时长超过平均时长',
  auto_156_4a5bd9d8: '答题过快且做错',
  auto_157_4fa255ac: '跳视频且做错',
  auto_158_b950ac31: '发呆次数中途离开次数',
  auto_159_19fcd54d: '学习状态不在线',
  auto_160_11540b79: '学不动',
  auto_161_cdda286b: '胡乱答题',
  auto_162_73c63a4c: '不专注',
  auto_163_4706dfb4: '跳过视频且错',
  auto_164_5eb2cb24: '草稿书写率低',
  auto_165_32b092a6: '例题试做率低',
  auto_166_bb0dec1c: '错因分析完成率低',
  auto_167_7c265b59: '学习时长过低',
  auto_168_d53fd8ce: '发呆',
  auto_169_dfaf2fe9: '中途离开',
  auto_170_694677ae: '连错',
  auto_171_197284ff: '答题过快',
  auto_172_9ce33983: '答题过慢',
  auto_173_2a8aa150: '跳视频',
  auto_9_7702c220: '个视频的试做看了仍然不会请关注',
  auto_10_94d8dc85: '操作',
  auto_72_200c7f02: '周合计',
  auto_73_1aa0cbc1: '题目数',
  auto_74_f371ad39: '占比',
  auto_75_f461c84a: '错误类别',
  auto_76_32e0744f: '审题问题',
  auto_77_ca6e3a94: '计算错误',
  auto_78_17d9fd5b: '该题不会',
  auto_79_fec0a1ff: '系统识别错误',
  auto_80_b56f5e7f: '其他',
  auto_81_e848b086: '周日',
  auto_82_50b93981: '周一',
  auto_83_57aa31d8: '周二',
  auto_84_a073d31c: '周三',
  auto_85_8e0080c1: '周四',
  auto_86_0e2944a3: '周五',
  auto_87_d62a1027: '周六',
  auto_88_d6d18239: '周日',
  auto_89_91107ea9: '周一',
  auto_90_bfb825f6: '周二',
  auto_91_398b2be6: '周三',
  auto_92_923a6343: '周四',
  auto_93_167b0d71: '周五',
  auto_94_85c18c37: '周六',
  auto_95_1f14b816: '做了',
  auto_96_fd486a7b: '没做',
  auto_97_3ac813a4: '不需要做',
  auto_98_c51048bb: '不需要做',
  auto_99_68c14998: '发呆',
  auto_100_f163cf3e: '中途离开',
  auto_101_d583cfee: '连错',
  auto_102_c7481dd3: '答题过慢',
  auto_103_ea985fd9: '答题过快',
  auto_104_4bfe4284: '跳视频',
  auto_105_57d57fcb: '周合计',
  auto_106_2761a940: '周合计',
  auto_107_f5812327: '周合计',
  auto_108_59fb5aa1: '学习异常',
  auto_109_cbfa7f73: '连续周',
  auto_110_a746491a: '超过次',
  auto_111_543c525a: '连续周',
  auto_112_8c6b4fd7: '本周超过次',
  auto_113_85b7ea72: '持续',
  auto_1_92ac947e: 'facePhotoSpec',
  auto_1_af831ca6: 'internalAccountTip',
  auto_2_8680ff0e: 'facePhotoSpec',
  auto_2_cdaf92ef: 'internalAccountTip',
  auto_3_492f529f: 'facePhotoSpec',
  auto_5_6926543b: '续期',
  auto_6_dcb6f800: '员工学习账号已开启智能风险防控功能为员工申请账号需上传人脸信',
  auto_46_0269e1a7: '姓名',
  auto_47_2c563fe1: '手机号',
  auto_48_25b1635b: '员工账号状态',
  auto_49_67388bbd: '学习账号状态',
  auto_50_8c579ca9: '人脸信息录入状态',
  auto_51_ecb0aad5: '账号',
  auto_52_623e4ad2: '密码',
  auto_53_865532f4: '申领时间',
  auto_54_9872669f: '申领人',
  auto_55_a0aaef39: '累计学习时长',
  auto_56_9da20d34: '有效打地基时长',
  auto_57_4404a352: '申领员工学习账号',
  auto_58_d137d18a: '该员工学习账号尚未录',
  auto_59_57b30a83: '员工姓名',
  auto_60_d8558a9f: '申领员工学习账号',
  auto_61_bfa0d9bd: '选择员工',
  auto_62_acd6af11: '人脸信息补录',
  auto_63_45ee5864: '该员工学习账号尚未录',
  auto_64_9b6a6432: '员工姓名',
  auto_65_12e98425: '人脸信息更新',
  auto_66_e952fd8b: '员工姓名',
  auto_67_cc2666cb: '照片并非成人是否确定',
  auto_68_1eda70cf: '提示',
  auto_69_e81d7d59: '确定',
  auto_70_900ca9ea: '取消',
  auto_71_f97bdd1c: '只能上传格式的图片',
  auto_2_8ca8fe3a: '注意:如需修改员工手机号，请在开通账号后由员工登录账号前往账号安全中心修改',
  auto_3_185fe505: '经销商系统',
  auto_4_5a97edcd: '辅助分析系统',
  auto_17_bf9a90f1: '汉天话务系统',
  auto_18_1ad7b8b4: '汉天话务系统',
  auto_19_1d37d402: '易迅话务系统',
  auto_20_26847597: '易迅话务系统',
  auto_21_171a6e64: '汉天话务系统',
  auto_22_25772312: '投资人',
  auto_23_8a044272: '汉天话务系统',
  auto_24_551e9c46: '易迅话务系统',
  auto_25_a4b78e20: '汉天话务系统',
  auto_26_83f5dffb: '易迅话务系统',
  auto_27_89da19db: '汉天话务系统',
  auto_28_1c224ce0: '易迅话务系统',
  auto_29_6fed4f90: '汉天话务系统',
  auto_30_0f3124fe: '易迅话务系统',
  auto_31_767a0f0a: '汉天话务系统',
  auto_32_712e9572: '汉天话务系统',
  auto_33_6ba38b4a: '投资人',
  auto_186_ec018485: '全部',
  auto_187_52b1e87b: '新生姓名',
  auto_188_59607ccf: '新生周期',
  auto_189_317f9f06: '负责督学师',
  auto_190_c6404dc3: '总学习时长',
  auto_191_b98e5332: '题目圈画情况',
  auto_192_1f1d4f0a: '草稿书写情况',
  auto_193_027dea62: '例题试做情况',
  auto_194_c09bf149: '错因分析',
  auto_195_b76e8428: '自主流程讲解',
  auto_196_17bc2fdf: '首周反馈',
  auto_197_e981487a: '本能级讲解',
  auto_198_4803b6e8: '健康升降级讲解',
  auto_199_ed031edd: '最近三次成绩',
  auto_208_03332d86: '暂无数据',
  auto_209_c2ddbe66: '成绩收集率',
  auto_210_0e770f18: '收集成绩数',
  auto_211_08833df5: '督学学生',
  auto_212_99ec8ae3: '有效成绩率',
  auto_213_735a30c2: '有效成绩数',
  auto_214_ca729786: '督学学生',
  auto_215_6018038c: '大考提分率',
  auto_216_d5526d42: '提分学生数',
  auto_217_1af8b376: '提交两次成绩督学学生',
  auto_218_e74b5add: '秋季',
  auto_219_331c0d4a: '春季',
  auto_220_58b31698: '期中考试',
  auto_221_100dfbd5: '期末考试',
  auto_230_6776c21f: '暂无数据',
  auto_231_13483fef: '成绩收集率',
  auto_232_50e70984: '收集成绩数',
  auto_233_3d44a397: '督学学生',
  auto_234_6b5abcc2: '有效成绩率',
  auto_235_83f283e7: '有效成绩数',
  auto_236_0b37fa51: '督学学生',
  auto_237_63eee629: '大考提分率',
  auto_238_fc1aae13: '提分学生数',
  auto_239_55dd988b: '提交两次成绩督学学生',
  auto_240_9a60e0ea: '秋季',
  auto_241_7bdfad88: '春季',
  auto_242_79576c05: '期中考试',
  auto_243_77e933f3: '期末考试',
  auto_12_0a666e12: '导出',
  auto_34_4bac84df: '姓名',
  auto_35_b2bf97cf: '姓名',
  auto_36_b99b6c5e: '离职日期',
  auto_37_f5c5a2ff: '姓名',
  auto_38_6cdce436: '手机号',
  auto_39_a4ff4163: '离职时间',
  auto_40_72825acf: '操作人',
  auto_41_923e5f12: '创建时间',
  auto_42_12e670c5: '潜在客户',
  auto_43_f1ef794e: '潜在学员',
  auto_44_54c4176d: '督学学员',
  auto_45_307b3d02: '金币',
  auto_174_4ca0c639: '督学师',
  auto_175_1e487d14: '请选择督学师',
  auto_176_e072ae03: '年份',
  auto_177_549f4edc: '请选择年份',
  auto_178_1451d388: '督学师',
  auto_179_a6fe13a2: '月份',
  auto_180_cc0cd5d6: '总得分',
  auto_181_7b6ddcf5: '学习时长',
  auto_182_70d25397: '高度活跃',
  auto_183_dd5a5f81: '学习过程异常',
  auto_184_e239f301: '学习留痕',
  auto_185_3f249f0b: '三月服务留存率',
  auto_248_97c154c8: '汉天话务系统',
  auto_249_b42d7796: '汉天话务系统',
  auto_250_17c33397: '易迅话务系统',
  auto_251_c1c0bfb5: '易迅话务系统',
  auto_252_0d9a129f: '汉天话务系统',
  auto_253_9ed6b9e2: '汉天话务系统',
  auto_254_1f305749: '易迅话务系统',
  auto_255_6f18d813: '汉天话务系统',
  auto_256_85a71b34: '易迅话务系统',
  auto_257_2a712ab4: '汉天话务系统',
  auto_258_e8ecdf89: '汉天话务系统',
  auto_259_16891ae0: '汉天话务系统',
  auto_260_c0643860: '易迅话务系统',
  auto_261_43a2877f: '易迅话务系统',
  auto_262_fc3c5be0: '汉天话务系统',
  auto_263_60d9d1ff: '汉天话务系统',
  auto_264_265e938b: '易迅话务系统',
  auto_265_e642aeee: '汉天话务系统',
  auto_266_240dd5d6: '易迅话务系统',
  auto_267_009e35da: '汉天话务系统',
  auto_200_cedb377d: '期中考',
  auto_201_c72bfc09: '期末考',
  auto_202_7a7919ce: '成绩收集率',
  auto_203_621bd16f: '服务中心督学自习室仅',
  auto_204_4bd58f38: '有效成绩率',
  auto_205_9cb80b2f: '当前大考成绩中有成绩',
  auto_206_3ee43d9c: '大考提分率',
  auto_207_a12ebc3f: '分子本次大考分数比前',
  auto_222_6d6d75ba: '期中考',
  auto_223_2ccf65e2: '期末考',
  auto_224_8d1511b9: '成绩收集率',
  auto_225_ae854796: '服务中心督学（自习室+仅线上）学生中，已收集到大考成绩的学生数占比',
  auto_226_6249da25: '有效成绩率',
  auto_227_4c808c87: '当前大考成绩中有成绩证明的督学学生数占比',
  auto_228_c1e58a43: '大考提分率',
  auto_229_b037e052: '分子：本次大考分数比前一次大考分数高的督学学生数。 | 分母：提交了连续两次大考有效成绩的督学学生数',
  auto_11_1f510f9d: '自定义角色',
  auto_1_cc870123: '复制邀请',
  auto_2_0fe929a0: '分配权限',
  auto_292_27cb13d9: '正常',
  auto_13_103986be: '导出',
  auto_14_3948439b: '导出',
  auto_15_66896e7e: '导出',
  auto_16_59bad31d: '导出',
  auto_17_f2d02b17: '导出报表',
  auto_18_4d93b56b: '导出报表',
  auto_19_24b12701: '导出报表',
  auto_20_84dbc023: '导出报表',
  auto_21_a73ef1c9: '导出',
  auto_22_e22d4af4: '导出报表',
  auto_23_c83fd579: '导出报表',
  auto_24_f20624c1: '导出报表',
  auto_25_6ca8b5f2: '导出报表',
  auto_26_1e9ac54b: '导出报表',
  auto_27_b9cdcac3: '导出报表',
  auto_28_7f6fac7f: '导出报表',
  auto_29_46075933: '导出报表',
  auto_30_74c980a5: '导出报表',
  auto_31_4eb86c8d: '导出报表',
  auto_32_34900b5f: '导出报表',
  auto_7_b9f5df3b: '数据更新时间',
  auto_8_a16e1f4a: '无图片',
  auto_281_3f293f12: '未填写',
  auto_282_fc8617d3: '未到店督学',
  auto_268_ad79dcb5: '督学师',
  auto_269_179481a8: '请选择督学师',
  auto_270_be5d6edf: '月份',
  auto_271_08422b87: '请选择月份',
  auto_285_548986fa: '期中考',
  auto_286_a09cfab4: '期末考',
  auto_287_bacb05df: '学科',
  auto_288_a0ae573b: '请选择学科',
  auto_272_7849a449: '督学师',
  auto_273_016ee162: '请选择督学师',
  auto_274_866d6785: '月份',
  auto_275_bb78fd4d: '请选择月份',
  auto_276_cbfd49b4: '督学师',
  auto_277_0a55bb3c: '请选择督学师',
  auto_278_343826d3: '月份',
  auto_279_6a7d3c7b: '请选择月份',
  auto_289_35cc9d39: '督学师',
  auto_290_6b7066bf: '请选择督学师',
  auto_291_65a1cd2a: '服务留存率&高度活跃率',
  auto_283_43133031: '已完成',
  auto_284_56ca29d8: '全部',
  auto_244_74f9687b: '数学',
  auto_245_2d033ec9: '英语',
  auto_246_b3637dcf: '物理',
  auto_247_1e45c663: '化学',
  auto_280_a644deaf: '单个',
  auto_293_8396209e: '期中考',
  auto_294_b254bd84: '期末考',
  supervisorStatusFormat: '督学状态：自习室（{selfStudy}），仅线上（{onlineOnly}）',
  timeRangeOctNov: '10~11月',
  timeRangeAprMay: '4~5月',
  timeRangeJanFeb: '1~2月',
  timeRangeJunJul: '6~7月',
  dateFormatYMD: '{year}年{month}月{day}日',
  exceptionSeveritySingle: '单日/单周触发异常场景',
  alarmTriggerCondition5: '连续有3题,每一道答题时长<平均时长1/3,且3题中有答案不正确',
  alarmTriggerCondition6: '视频的有效播放时长<视频1/3或未播放,后续的题目做错',
  ordOne: '一',
  ordTwo: '二',
  ordThree: '三',
  ordFour: '四',
  ordFive: '五',
  ordSix: '六',
  ordSeven: '七',
  ordEight: '八',
  ordNine: '九',
  ordTen: '十',
  minuteUnit: '分钟',
  secondUnit: '秒',
  courseLevelUnit: '级',
  courseBatchUnit: '次',
  ordPrefix: '第',
  timesUnit: '次',
  hasPrefix: '，有',
};
